export class Focustrap {

    private _state: boolean = false;
    private menu: HTMLElement | null;
    private toggleButton: HTMLElement | null;

    constructor() {
        this.menu = document.querySelector('.menu-overlay');
        this.toggleButton = document.querySelector('.header-menu-toggle');

        this.toggleButton?.addEventListener('click', () => {
            this.state = !this.state;
        });
    }

    public set state(value: boolean) {
        this._state = value;

        if (this._state) {
            this.menu?.classList.add('-active');
            const focusableSelectors = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const focusableElements: NodeListOf<HTMLElement> = this.menu ? this.menu.querySelectorAll(focusableSelectors) : document.createElement('div').querySelectorAll(focusableSelectors);
            const firstFocusable = focusableElements[0] as HTMLElement;
            const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

            this.enableFocusTrap(firstFocusable, lastFocusable);
        } else {
            this.menu?.classList.remove('-active');
            this.removeFocusTrap();
        }
    }

    public get state(): boolean {
        return this._state;
    }

    private enableFocusTrap(firstFocusable: HTMLElement, lastFocusable: HTMLElement) {
        const handleFocusTrap = (event: KeyboardEvent) => {
            if (event.key === 'Tab') {
                if (event.shiftKey) {
                    if (document.activeElement === firstFocusable) {
                        event.preventDefault();
                        lastFocusable.focus();
                    }
                } else {
                    if (document.activeElement === lastFocusable) {
                        event.preventDefault();
                        firstFocusable.focus();
                    }
                }
            } else if (event.key === 'Escape') {
                this.state = false;
            }
        }

        this.menu?.addEventListener('keydown', handleFocusTrap);
        
        (this.menu as any).cleanupFocusTrap = () => {
            this.menu?.removeEventListener('keydown', handleFocusTrap);
        };

        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            firstFocusable.focus();
        }
    }

    private removeFocusTrap() {
        if (this.menu && (this.menu as any).cleanupFocusTrap) {
            (this.menu as any).cleanupFocusTrap();
        }
    }
}
